var StockType;
(function (StockType) {
    StockType["TEXT"] = "TEXT";
    StockType["URL"] = "URL";
    StockType["QR"] = "QRCODE";
    StockType["PDF"] = "PDF";
    StockType["FILE"] = "FILE";
})(StockType || (StockType = {}));
export default StockType;
